import * as logger from '../utils/logger';
import { messageNamespace } from '../constants';

const context = cast.framework.CastReceiverContext.getInstance();
const log = logger.create('MessageInterceptor');
const listeners = {};

/**
 * Adds a custom listener to list.
 *
 * @export
 * @param {string} eventName Name of the event to listen.
 * @param {function} listener Listener executed when event is received.
 */
export function addCustomListener(eventName, listener) {
  if (!listeners[eventName]) {
    listeners[eventName] = {};
  }
  listeners[eventName] = listener;
}

/**
 * Registers a message listener.
 *
 * @export
 * @param {string} eventName Name of the event to listen.
 * @param {function} listener Listener executed when event is received.
 */
export function registerCustomListener() {
  context.addCustomMessageListener(messageNamespace, ({ data }) => {
    const { type, value } = data;
    log.info('Custom event received:', data.type);
    listeners[type](value);
  });
}

/**
 * Adds a listener to the playerManager.
 *
 * @param {cast.framework.messages.MessageType} messageType Type of the message.
 * @param {function} listener Listener executed.
 */
export function addListener(messageType, listener) {
  const context = cast.framework.CastReceiverContext.getInstance();
  const playerManager = context.getPlayerManager();

  playerManager.setMessageInterceptor(messageType, listener);
}

/**
 * Broadcast a custom message to the sender.
 *
 * @export
 * @param {string} type Message broadcasted.
 * @param {Object} value Value.
 */
export function broadcast(type, value) {
  const context = cast.framework.CastReceiverContext.getInstance();
  const msg = value ? { type, value } : { type };
  context.sendCustomMessage(messageNamespace, undefined, msg);
  log.info('Custom message sent:', messageNamespace, msg);
}
